class Dashboard {
    constructor(organizationID, start, end) {
        this.start = start;
        this.end = end;
        this.organizationID = organizationID;
        this.connectedTimeChartRendered = false;
        this.connectedTimeChart = null;
        this.encryptedDataChartRendered = false;
        this.encryptedDataChart = null;
        this.osUsageChartRendered = false;
        this.osUsageChart = null;
        this.mostActiveUsersDatatable = null;
        this.changeOrganizationNameFormValidation();
        this.calendarPicker();
        this.getData();
        new DownloadableConfigs();
    }

    changeOrganizationNameFormValidation(){
        let form = document.getElementById('frm-changeOrganizationNameForm-changeOrganizationNameForm');
        if(form){
            let submitButton = document.getElementById('change_organization_name_form_submit');

            form.querySelector('input[name=name]').addEventListener('input', function (e) {
                $(this).val(function () {
                    return this.value.replace(/\s+/g, '-');
                });
            });

            FormValidation.formValidation(
                form,
                {
                    fields: {
                        'name': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    min: 3,
                                    max: 45,
                                    message: 'Team Name has to be between 3 and 145 characters long',
                                },
                                regexp: {
                                    regexp: /^[a-zA-Z0-9\-]*$/,
                                    message: 'Team Name contains invalid characters. Allowed characters: a-z, A-Z, 0-9 and -',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '?do=changeOrganizationNameForm-checkOrganizationName',
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                name: 0.5
                            },
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                    }
                }
            ).on('core.form.validating', function(event) {
                new DismissModal('change_organization_name_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('change_organization_name_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
    addOrRemoveContentLoading(){
        // Init block ui
        const elements = document.querySelectorAll('.dashboard-data-overlay');
        elements.forEach(element => {
            let blockUI = KTBlockUI.getInstance(element);
            if(!blockUI){
                blockUI = new KTBlockUI(element, {
                    overlayClass: "ga-bg-primary-200",
                });
            }
            if (blockUI.isBlocked()) {
                blockUI.release();
            } else {
                blockUI.block();
            }
        });
    }
    calendarPicker(){
        let thisClass = this;
        let dashboardDatePicker = $('.dashboard-date-picker-title');
        $('.dashboard-date-picker-menu .menu-link').on('click', function () {
            $('.dashboard-date-picker-menu .menu-link.active').removeClass('active border-3 border-start border-danger');
            $(this).addClass('active border-3 border-start border-danger');
            dashboardDatePicker.text(this.attributes.range.value);
            thisClass.start = this.attributes.start.value;
            thisClass.end = this.attributes.end.value;
            thisClass.getData();
        })
    }
    getData(){
        let thisClass = this;
        this.addOrRemoveContentLoading();

        $.ajax({
            url: '?do=getUsageReportData',
            type: 'POST',
            dataType: '',
            data: {organizationID: this.organizationID, start: this.start, end: this.end}
        }).done(function(data) {
            thisClass.changeContent(data);
        })
    }
    changeContent(data){
        this.changeBlockedThreats(data['thisWeek']['blockedThreats'], this.start, this.end);
        this.changeDeviceHealth(data['thisWeek']['deviceHealth'], this.start, this.end);
        this.renderOsUsageChart(data['thisWeek']['usedOS']['data'], data['thisWeek']['usedOS']['labels']);
        this.renderMostActiveUsers(data['thisWeek']['vpnUsers'], data['editMembers']);
        this.renderLocationsMap(data['thisWeek']['locations']);

        let valuesEncryptedDataArr = [];
        let valuesConnectedTimeArr = [];
        let labelsEncryptedDataArr = [];
        for(let i = 0; i < data['lastWeeks'].length; i++){
            valuesEncryptedDataArr.push(data['lastWeeks'][i]['dataEncryptedGB']);
            valuesConnectedTimeArr.push(data['lastWeeks'][i]['connectedHours']);
            labelsEncryptedDataArr.push(data['lastWeeks'][i]['splitDateRange']);
        }
        valuesEncryptedDataArr.push(data['thisWeek']['dataEncryptedGB']);
        valuesConnectedTimeArr.push(data['thisWeek']['connectedHours']);
        labelsEncryptedDataArr.push(data['thisWeek']['splitDateRange']);

        this.renderConnectedTimeChart(valuesConnectedTimeArr, labelsEncryptedDataArr, data['thisWeek']['connectedHours']);
        this.renderDataEncryptedChart(valuesEncryptedDataArr, labelsEncryptedDataArr, data['thisWeek']['dataEncryptedGB']);

        this.addOrRemoveContentLoading();
    }
    changeBlockedThreats(blockedThreats, start, end){
        let seeMoreDetails = $('.dashboard-blocked-threats .see-more-details');
        let noBlockedThreats = $('.dashboard-blocked-threats .no-blocked-threats');
        let blockedThreatsNumber = $('.dashboard-blocked-threats #blockedThreatsNumber');

        if(blockedThreats > 0){
            blockedThreatsNumber.addClass('text-danger');
            blockedThreatsNumber.removeClass('text-primary');

            let threatsNumberCountUp = new countUp.CountUp('blockedThreatsNumber', blockedThreats);
            if (!threatsNumberCountUp.error) {
                threatsNumberCountUp.start();
            }

            seeMoreDetails.attr('href', '/secure-shield/?organizationID='+this.organizationID+'&start='+start+'&end='+end);
            seeMoreDetails.removeClass('d-none');
            noBlockedThreats.addClass('d-none');
        } else {
            blockedThreatsNumber.addClass('text-primary');
            blockedThreatsNumber.removeClass('text-danger');
            blockedThreatsNumber.text(blockedThreats);
            seeMoreDetails.addClass('d-none');
            noBlockedThreats.removeClass('d-none');
        }
    }
    changeDeviceHealth(deviceHealth, start, end){
        let seeMoreDetails = $('.dashboard-device-security-risks .see-more-details');
        let noDeviceHealth = $('.dashboard-device-security-risks .no-device-security-risks');
        let deviceSecurityRisksNumber = $('.dashboard-device-security-risks #deviceSecurityRisksNumber');

        if(deviceHealth > 0){
            deviceSecurityRisksNumber.addClass('text-danger');
            deviceSecurityRisksNumber.removeClass('text-primary');

            let threatsNumberCountUp = new countUp.CountUp('deviceSecurityRisksNumber', deviceHealth);
            if (!threatsNumberCountUp.error) {
                threatsNumberCountUp.start();
            }

            seeMoreDetails.attr('href', '/devices/?organizationID='+this.organizationID+'&start='+start+'&end='+end+'&status=failed');
            seeMoreDetails.removeClass('d-none');
            noDeviceHealth.addClass('d-none');
        } else {
            deviceSecurityRisksNumber.addClass('text-primary');
            deviceSecurityRisksNumber.removeClass('text-danger');
            deviceSecurityRisksNumber.text(deviceHealth);
            seeMoreDetails.addClass('d-none');
            noDeviceHealth.removeClass('d-none');
        }
    }
    renderConnectedTimeChart(valuesArr, labelsArr, thisWeekValue){
        const connectedTimeChartElement = $("#dashboard_time_connected_chart");
        const thisClass = this;
        const primaryColor = KTUtil.getCssVariableValue('--bs-primary');
        const borderColor = KTUtil.getCssVariableValue('--bs-primary-600');
        const secondaryColor = KTUtil.getCssVariableValue('--bs-danger');

        let valuesSum = valuesArr.reduce((a, b) => a + b, 0);
        let noActivity = $('.dashboard-time-chart.no-activity');
        let showActivity = $('.dashboard-time-chart.show-activity');

        if(valuesSum > 0) {
            noActivity.hide();

            const options = {
                series: [{
                    name: 'Duration',
                    data: valuesArr
                }],
                chart: {
                    fontFamily: 'inherit',
                    type: 'bar',
                    height: 130,
                    toolbar: {
                        show: false
                    },
                    sparkline: {
                        enabled: true
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: ['55%'],
                        borderRadius: 6,
                        distributed: true,
                        borderRadiusApplication: 'end'
                    }
                },
                legend: {
                    show: false,
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 9,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: labelsArr,
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                        tickPlacement: 'between'
                    },
                    labels: {
                        show: false,
                        style: {
                            colors: primaryColor,
                            fontSize: '12px'
                        }
                    },
                    crosshairs: {
                        show: false
                    }
                },
                yaxis: {
                    labels: {
                        show: false,
                        style: {
                            colors: primaryColor,
                            fontSize: '12px'
                        },
                        formatter: (value) => { return value.toFixed(0) },
                    }
                },
                colors: [primaryColor, primaryColor, primaryColor, secondaryColor],
                fill: {
                    opacity: 1
                },
                tooltip: {
                    style: {
                        fontSize: '12px'
                    },
                    y: {
                        formatter: function (val) {
                            return thisClass.formatConnectedTime(val);
                        }
                    }
                },
                grid: {
                    padding: {
                        left: 10,
                        right: 10
                    },
                    borderColor: borderColor,
                    strokeDashArray: 4,
                    yaxis: {
                        lines: {
                            show: true
                        }
                    }
                }
            };

            let hoursConnected = Math.floor(thisWeekValue);
            let minutesConnected = Math.round((thisWeekValue * 60) % 60);
            let hoursCountUp = new countUp.CountUp('selected_week_connected_time_h', hoursConnected, {
                suffix: 'h',
            });
            if (!hoursCountUp.error) {
                hoursCountUp.start();
            }
            let minutesCountUp = new countUp.CountUp('selected_week_connected_time_m', minutesConnected, {
                suffix: 'm',
            });
            if (!minutesCountUp.error) {
                minutesCountUp.start();
            }

            if (this.connectedTimeChartRendered) {
                noActivity.hide();
                showActivity.show();
                this.connectedTimeChart.updateOptions(options);
            } else {
                this.connectedTimeChart = new ApexCharts(connectedTimeChartElement[0], options);
                this.connectedTimeChartRendered = true;
                noActivity.hide();
                showActivity.show();
                this.connectedTimeChart.render();
            }
        } else {
            noActivity.show();
            showActivity.hide();
        }
    }
    formatConnectedTime(value, mostActiveUsers = false){
        /** Value is in minutes */
        let hoursConnected = Math.floor(value);
        let minutesConnected = Math.round((value * 60) % 60);
        if (hoursConnected > 0 && minutesConnected > 0) {
            return hoursConnected + 'h ' + minutesConnected + 'min';
        } else if (hoursConnected > 0 && minutesConnected === 0) {
            return hoursConnected + 'h ' + (mostActiveUsers ? '00min' : '');
        } else {
            return minutesConnected + 'min';
        }
    }
    renderDataEncryptedChart(valuesArr, labelsArr, thisWeekValue){
        const dataEncryptedChartElement = $("#dashboard_data_encrypted_chart");
        const primaryColor = KTUtil.getCssVariableValue('--bs-primary');
        const borderColor = KTUtil.getCssVariableValue('--bs-primary-600');
        const secondaryColor = KTUtil.getCssVariableValue('--bs-danger');

        let valuesSum = valuesArr.reduce((a, b) => a + b, 0);
        let noActivity = $('.dashboard-data-encrypted-chart.no-activity');
        let showActivity = $('.dashboard-data-encrypted-chart.show-activity');

        if(valuesSum > 0) {
            noActivity.hide();

            const options = {
                series: [{
                    name: 'Duration',
                    data: valuesArr
                }],
                chart: {
                    fontFamily: 'inherit',
                    type: 'bar',
                    height: 130,
                    toolbar: {
                        show: false
                    },
                    sparkline: {
                        enabled: true
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: ['55%'],
                        borderRadius: 6,
                        distributed: true,
                        borderRadiusApplication: 'end',
                    }
                },
                legend: {
                    show: false,
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 9,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: labelsArr,
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                        tickPlacement: 'between'
                    },
                    labels: {
                        show: false,
                        style: {
                            colors: primaryColor,
                            fontSize: '12px'
                        }
                    },
                    crosshairs: {
                        show: false
                    }
                },
                yaxis: {
                    labels: {
                        show: false,
                        style: {
                            colors: primaryColor,
                            fontSize: '12px'
                        },
                        formatter: (value) => { return value.toFixed(0) },
                    }
                },
                colors: [primaryColor, primaryColor, primaryColor, secondaryColor],
                fill: {
                    opacity: 1
                },
                tooltip: {
                    style: {
                        fontSize: '12px'
                    },
                    y: {
                        formatter: function (val) {
                            return val + "GB"
                        }
                    }
                },
                grid: {
                    padding: {
                        left: 10,
                        right: 10
                    },
                    borderColor: borderColor,
                    strokeDashArray: 4,
                    yaxis: {
                        lines: {
                            show: true
                        }
                    }
                }
            };

            let dataEncryptedCountUp = new countUp.CountUp('selected_week_data_encrypted', thisWeekValue, {
                suffix: ' GB',
                decimalPlaces: 2
            });
            if (!dataEncryptedCountUp.error) {
                dataEncryptedCountUp.start();
            }

            if (this.encryptedDataChartRendered) {
                noActivity.hide();
                showActivity.show();
                this.encryptedDataChart.updateOptions(options);
            } else {
                this.encryptedDataChart = new ApexCharts(dataEncryptedChartElement[0], options);
                this.encryptedDataChartRendered = true;
                noActivity.hide();
                showActivity.show();
                this.encryptedDataChart.render();
            }
        } else {
            noActivity.show();
            showActivity.hide();
        }
    }
    renderOsUsageChart(valuesArr, labelsArr){
        let osUsageChartElement = $("#dashboard_os_usage_chart");
        let noActivity = $('.dashboard-most-frequent-os .no-activity');

        const primaryColor = KTUtil.getCssVariableValue('--bs-primary');
        const secondaryColor = KTUtil.getCssVariableValue('--bs-danger');
        const successColor = KTUtil.getCssVariableValue('--bs-success');
        const warningColor = KTUtil.getCssVariableValue('--bs-warning');
        const primaryDarkColor = KTUtil.getCssVariableValue('--bs-primary-dark');
        const secondaryDarkColor = KTUtil.getCssVariableValue('--bs-danger-dark');


        if(valuesArr.length !== 0){
            const options = {
                chart: {
                    type: 'donut',
                    width: 320,
                },
                dataLabels: {
                    enabled: false,
                },
                colors: [primaryColor, secondaryColor, successColor, warningColor, primaryDarkColor, secondaryDarkColor],
                series: valuesArr,
                labels: labelsArr,
                legend: {
                    position: 'right',
                    horizontalAlign: 'top',
                    fontSize: '12px',
                    labels: {
                        colors: primaryColor
                    },
                    offsetY: 50,
                    markers: {
                        width: 12,
                        height: 12,
                        radius: 0
                    },
                    itemMargin: {
                        vertical: 3
                    },
                },
                tooltip: {
                    enabled: true,
                    style: {
                        fontSize: '12px',
                    },
                    custom: function({series, seriesIndex, dataPointIndex, w}) {
                        return '<div style="background: '+w.config.colors[seriesIndex]+'; padding: 2px; color: #fff0ff !important;">'+w.config.labels[seriesIndex]+'</div>';
                    }
                }
            };

            if(this.osUsageChartRendered){
                noActivity.hide();
                osUsageChartElement.show();
                this.osUsageChart.updateOptions(options);
            } else {
                this.osUsageChart = new ApexCharts(osUsageChartElement[0], options);
                this.osUsageChartRendered = true;
                noActivity.hide();
                osUsageChartElement.show();
                this.osUsageChart.render();
            }
        } else {
            noActivity.show();
            osUsageChartElement.hide();
        }
    }
    renderMostActiveUsers(data, editMembers){
        let thisClass = this;
        let noActivity = $('.dashboard-most-active-users .no-activity');
        let showMoreActiveUsers = document.querySelector('.dashboard-most-active-users .show-more-most-active-users');
        let showActivity = $('.dashboard-most-active-users .show-activity');
        let mostActiveUsersTable = $("#dashboard_most_active_users_table");

        if(data.length !== 0){
            let html = '';

            let maxMembers = (data.length > 5 ? 5 : data.length);
            for(let i = 0; i < maxMembers; i++){
                let connectedTime = this.formatConnectedTime((data[i]['connectedMinutes']/60), true);
                let avatarHtml;
                let name;
                if(data[i]['uuid']){
                    name = data[i]['name'];
                    if (data[i]['password'] || data[i]['isIdp']){
                        if (data[i]['avatarID'] || data[i]['isIdp']){
                            avatarHtml = '<img alt="avatar" class="h-30px'+(data[i]['isBlocked'] === 1 ? ' filter-grayscale' : '')+'" src="/media/goodaccess/avatars/svg/Icon with face-'+data[i]['avatarID']+'.svg" />';
                        } else {
                            avatarHtml = '<img alt="avatar" class="h-30px'+(data[i]['isBlocked'] === 1 ? ' filter-grayscale' : '')+'" src="/media/goodaccess/avatars/svg/device.svg" />';
                        }
                    } else {
                        avatarHtml = '<i class="fa-solid fa-user-clock fs-1'+(data[i]['isBlocked'] === 1 ? ' text-grey-600' : '')+'"></i>';
                    }
                } else {
                    name = data[i]['name'];
                    avatarHtml = '<img alt="avatar" class="h-30px'+(data[i]['isBlocked'] === 1 ? ' filter-grayscale' : '')+'" src="/media/goodaccess/avatars/svg/Icon with face-unknown2.svg" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="deleted user" />';
                }
                if(data[i]['isBlocked'] === 1) {
                    avatarHtml += '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-10px h-10px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="blocked">' +
                                      '&#10005;' +
                                  '</span>';
                }
                html += '<tr>' +
                    '        <td>' +
                    '            <div class="d-flex align-items-center">' +
                    '                <div class="symbol symbol-30px me-3">' +
                                        avatarHtml+
                    '                </div>' +
                    '                <div class="d-flex justify-content-start flex-column" '+(editMembers ? 'id="'+data[i]['uuid']+'"' : '')+'>' +
                    '                    <div class="'+(editMembers ? 'text-decoration-underline-ga primary edit-member ' : '')+'fs-6 text-primary">'+name+'</div>' +
                    '                </div>' +
                    '            </div>' +
                    '        </td>' +
                    '        <td class="text-end text-nowrap">' +
                    '            <span class="ga-text-primary-700 fw-bold fs-6">'+connectedTime+'</span>' +
                    '        </td>' +
                    '     </tr>';
            }
            mostActiveUsersTable.html(html);

            noActivity.hide();
            showActivity.show();

            if(showMoreActiveUsers){
                showMoreActiveUsers.classList.add('text-decoration-underline-ga', 'primary')
                showMoreActiveUsers.addEventListener('click', function () {
                    let membersActivityDate = document.querySelector('#most_active_users_table .members-activity-date');
                    let datePickerTitle = document.querySelector('.dashboard-date-picker .dashboard-date-picker-title');
                    if(membersActivityDate && datePickerTitle){
                        membersActivityDate.innerText = '('+datePickerTitle.textContent+')';
                    }
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('most_active_users_table'), {}).show();

                    if(thisClass.mostActiveUsersDatatable){
                        thisClass.mostActiveUsersDatatable.datatable.clear();
                        thisClass.mostActiveUsersDatatable.datatable.rows.add(data).draw();
                    } else {
                        thisClass.mostActiveUsersDatatable = new MostActiveUsersDatatable(data, editMembers);
                    }
                });
            }
        } else {
            noActivity.show();
            showActivity.hide();
            showMoreActiveUsers.classList.remove('text-decoration-underline-ga', 'primary')
        }
    }
    renderLocationsMap(data){
        let noActivity = $('.dashboard-connected-locations .no-activity');
        let showActivity = $('.dashboard-connected-locations .show-activity');
        
        let connectedLocationsMapElement = $('#dashboard_locations_map');
        let numberOfLocations = Object.keys(data).length;

        let locationsCountUp = new countUp.CountUp('number_of_connected_locations', numberOfLocations, {
            suffix: numberOfLocations === 1 ? ' location' : ' locations',
        });
        if (!locationsCountUp.error) {
            locationsCountUp.start();
        }

        if(numberOfLocations > 0) {
            new MapLoader({
                apiKey: "AIzaSyBSmM7dZo9rsu76fbtHpdpr8O7XaGnK1LM",
                version: "weekly",
                libraries: ["places"],
                language: "en"
            }).load().then(async (google) => {

                const map = new google.maps.Map(connectedLocationsMapElement[0], {
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    maxZoom: 15,
                    mapId: "GOODACCESS_MAP_ID",
                });

                /** create empty LatLngBounds object */
                let bounds = new google.maps.LatLngBounds();

                const infoWindow = new google.maps.InfoWindow({
                    content: "",
                    disableAutoPan: true,
                });

                const markers = [];
                const {AdvancedMarkerElement, PinElement} = await google.maps.importLibrary("marker");
                for (let i in data) {
                    let marker = new google.maps.marker.AdvancedMarkerElement({
                        position: new google.maps.LatLng(data[i]['latitude'], data[i]['longitude']),
                        map: map
                    });

                    let label = data[i]['users'].join(', ');
                    marker.addListener("gmp-click", () => {
                        infoWindow.setContent(label);
                        infoWindow.open(map, marker);
                    });
                    /** extend the bounds to include each marker's position */
                    bounds.extend(marker.position);
                    markers.push(marker);
                }

                const renderer = {
                    render({count, position}, stats) {
                        /** change color if this cluster has more markers than the mean cluster */
                        const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
                        /** create svg url with fill color */
                        const svg = window.btoa(`
                        <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                            <circle cx="120" cy="120" opacity="1" r="70" />
                            <circle cx="120" cy="120" opacity=".3" r="90" />
                            <circle cx="120" cy="120" opacity=".2" r="110" />   
                        </svg>`);
                        /** create marker using svg icon */
                        return new google.maps.Marker({
                            position,
                            icon: {
                                url: `data:image/svg+xml;base64,${svg}`,
                                scaledSize: new google.maps.Size(45, 45),
                            },
                            label: {
                                text: String(count),
                                color: "rgba(255,255,255,0.9)",
                                fontSize: "12px",
                            },
                            title: `Cluster of ${count} markers`,
                            /** adjust zIndex to be above other markers */
                            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                        });
                    }
                };

                /** Add a marker clusterer to manage the markers. */
                new MarkerClusterer({markers, map, renderer});

                /** now fit the map to the newly inclusive bounds */
                map.fitBounds(bounds);

                /** restore the zoom level after the map is done scaling */
                let listener = google.maps.event.addListener(map, "idle", function () {
                    google.maps.event.removeListener(listener);
                });

                noActivity.addClass('d-none');
                showActivity.removeClass('d-none');

            }).catch(e => {
                console.log('Error with loading Map.');
            });

        } else {
            noActivity.removeClass('d-none');
            showActivity.addClass('d-none');
        }
    }
}
window.Dashboard = Dashboard;